import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../pages/pages-shared.module';
import {HistoryModalComponent} from './history-modal.component';

@NgModule({
    imports: [
        PagesSharedModule
    ],
    declarations: [
        HistoryModalComponent
    ],
    entryComponents: [
        HistoryModalComponent
    ],
    exports: [
        HistoryModalComponent
    ]
})
export class HistoryModalModule {
}
